import { render, staticRenderFns } from "./ParallaxContainer.vue?vue&type=template&id=0b1498f8&scoped=true"
import script from "./ParallaxContainer.vue?vue&type=script&lang=js"
export * from "./ParallaxContainer.vue?vue&type=script&lang=js"
import style0 from "./ParallaxContainer.vue?vue&type=style&index=0&id=0b1498f8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b1498f8",
  null
  
)

export default component.exports